export const formatedLabel = (label: string) => {
  let _label = label
  switch (label) {
    case 'rugSize':
      _label = 'Size'
      break
    case 'rugColors':
      _label = 'Colors'
      break
    case 'rugPileHeight':
      _label = 'Pile'
      break
    case 'rugStyle':
      _label = 'Style'
      break
    case 'rugDesign':
      _label = 'Design'
      break
    case 'shape':
      _label = 'Shape'
      break
    case 'rugFiber':
      _label = 'Fiber'
      break
    default:
  }

  return _label
}
